<template>
    <Layout>
        <div class="row">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 mx-auto col-sm-12">
                        <div class="card-body pt-0">
                            <i class="bx bxs-file mb-3" style="font-size: 50px"></i>
                            <h3 class="mt-3">Ce site est inaccessible</h3><br>
                            <p>Vérifiez si l'adresse {{ getDomain }} est correcte.</p>
                            <p>DNS_PROBE_FINISHED_NXDOMAIN</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
export default {
    computed: {
        getDomain() {
            return window.location.hostname
        }
    }
}
</script>

<style>
.card-body {
    margin-top: 30vh;
}
</style>